import { CurrencyPipe, registerLocaleData } from "@angular/common";
import { LOCALE_ID, NgModule } from "@angular/core";
import localeDe from '@angular/common/locales/de';
import { API_URL, IMAGE_URL } from "@frontend/basic";
import { provideHttpClient } from "@angular/common/http";

@NgModule({
    providers: [
        provideHttpClient(),
        { provide: LOCALE_ID, useValue: 'de' },
        { provide: API_URL, useValue: 'testApiUrl' },
        { provide: IMAGE_URL, useValue: 'testImageUrl' },
        CurrencyPipe
    ]
})
export class FrontendTestModule 
{
    constructor() {
     registerLocaleData(localeDe, 'de');
    }
}